'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import Link from '@/components/Link';
import IconArrowBullet from '@/components/Icons/IconArrowBullet';

interface ListItem {
  href: string;
  slug: string;
  label: string;
}

interface Props extends React.HTMLAttributes<HTMLUListElement> {
  data: Array<ListItem>;
}

function LinkedList({ data, ...delegated }: Props) {
  const [hoveredLink, setHoveredLink] = React.useState<string | null>(
    null
  );
  return (
    <List {...delegated}>
      {data.map((item: ListItem) => (
        <li key={item.slug}>
          <CourseLink
            href={item.href}
            onMouseEnter={() => setHoveredLink(item.slug)}
            onMouseLeave={() => setHoveredLink(null)}
          >
            <Bullet isHovering={item.slug === hoveredLink} />
            {item.label}
          </CourseLink>
        </li>
      ))}
    </List>
  );
}

const List = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const CourseLink = styled(Link)`
  display: flex;
  gap: 8px;
  width: fit-content;
  padding-block: 4px;
  text-decoration: none;
  color: inherit;

  font-weight: var(--font-weight-medium);
`;

const Bullet = styled(IconArrowBullet)`
  margin-top: 2px;
`;

export default LinkedList;
